import React, { useState, useEffect } from "react";
import API_BASE_URL from "../config";
import axios from "axios";

export default function Fileuploader(props) {
  const [selectedFile, setSelectedFile] = useState();
  const [uploadMessage, setUploadMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileconfig, setFileConfig] = useState([]);
  const [savedFileDetails, setSavedFileDetails] = useState([]);
  const [compId, setCompId] = useState();

  useEffect(() => {
    const getFileConfig = async () => {
      const resDt = await fetch(`${API_BASE_URL}GetMasterData.php/14`);
      const resdtjson = await resDt.json();
      setFileConfig(await resdtjson.data);
    };
    getFileConfig();
  }, []);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setUploadProgress(0);
  };

  const handleUploadClick = (event) => {
    //console.log(compId);
    event.preventDefault();
    var err_msg = validateFileUpload();
    if (err_msg === "" || err_msg === "undefined") {
      uploadFile();
      //window.location.reload();
    } else {
      alert(err_msg);
    }
  };

  const validateFileUpload = () => {
    var strErr_Msg = "";
    if (selectedFile) {
      const allowedTypes = fileconfig[0].val.split(",");
      if (selectedFile.size > fileconfig[1].val) {
        strErr_Msg =
          strErr_Msg +
          "File size should not be greater than " +
          fileconfig[0].val / 1024 +
          "MB.";
        return strErr_Msg;
      }
    } else {
      strErr_Msg = strErr_Msg + "Please select file.";
      return strErr_Msg;
    }
    return strErr_Msg;
  };

  const uploadFile = async (params) => {
    const formInvstRepData = new FormData();
    formInvstRepData.append("file_upload", selectedFile);

    const templsaver = await axios
      .post(`${API_BASE_URL}UploadFile.php`, formInvstRepData, {
        hearders: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          setUploadProgress(progress);
        },
      })
      .then((response) => {
        //console.log();
        if (response.status === 200) {
          props.onUpload(
            props.id,
            JSON.stringify(response.data),
            props.ctrlName
          );
          setSavedFileDetails(response.data);
          setUploadMessage("File uploaded successfully");
        } else {
          setUploadMessage("Error uploading file");
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setUploadMessage("Error uploading file");
      });
  };

  const handleNewUpload = () => {
    setUploadMessage((prev) => (prev = ""));
    setSelectedFile((prev) => (prev = ""));
  };
  const RemoveFile = (event) => {
    event.preventDefault();
    props.onFileDelete(props.id);
    setUploadMessage((prev) => (prev = ""));
  };
  return (
    <div>
      {!props.fileName && (
        <>
          <div className="row mx-3">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <input
                    type="file"
                    accept="image/jpeg,image/png"
                    onChange={(e) => handleFileChange(e)}
                  />
                </div>
                <div className="col-6">
                  <button
                    className="btn btn-primary btn-circle btn-sm"
                    title="Upload File"
                    onClick={(e) => handleUploadClick(e)}
                  >
                    <i
                      className="fas fa-upload"
                      onClick={(e) => handleUploadClick(e)}
                    ></i>
                  </button>
                </div>
              </div>
              <div>
                <p className="small mt-2">
                  Note: Choose a file with .pdf, .jpg, .png file extension
                </p>
              </div>
              {uploadProgress > 0 && uploadProgress < 100 && (
                <div>
                  <p>Upload Progress: {uploadProgress}%</p>
                  <progress value={uploadProgress} max="100" />
                </div>
              )}
              {uploadMessage && <p className="small">{uploadMessage}</p>}
            </div>
          </div>
        </>
      )}
      {props.fileName && (
        <div className="row mx-3">
          <div className="col">
            <i
              className="text-danger fas fa-image mx-3"
              style={{ fontSize: 30 }}
            ></i>
            {props.fileName ? props.fileName : ""}
            <button
              className="btn btn-danger btn-circle btn-sm mx-3"
              onClick={(e) => RemoveFile(e)}
            >
              <i className="fa fa-trash mx-3" style={{ fontSize: 15 }} />
            </button>
          </div>
        </div>
      )}

      <div
        className="modal fade bd-example-modal-lg"
        id="file_uploader_modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="file_uploader_modalLabel"
        aria-hidden="true"
        height="60%"
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
          style={{ overflow: "hidden" }}
        >
          <div className="modal-content">
            <div class="modal-header">
              File Uploader
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {/*<div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col-6">
                    <input
                      type="file"
                      accept="image/jpeg,image/png"
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div>
                  <div className="col-6">
                    <button
                      className="btn btn-primary btn-circle btn-sm"
                      title="Upload File"
                      onClick={(e) => handleUploadClick(e)}
                    >
                      {id}
                      {/*<i
                        className="fas fa-upload"
                        onClick={(e) => handleUploadClick}
                      ></i>
                    </button>
                  </div>
                </div>
                <div>
                  <p className="small mt-2">
                    Note: Choose a file with .pdf, .jpg, .png file extension
                  </p>
                </div>
                {uploadProgress > 0 && uploadProgress < 100 && (
                  <div>
                    <p>Upload Progress: {uploadProgress}%</p>
                    <progress value={uploadProgress} max="100" />
                  </div>
                )}
                {uploadMessage && <p>{uploadMessage}</p>}
                <div>
                  <p className="small mt-2">Max file size:</p>
                </div>
                <div>&nbsp;</div>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}
